import { render } from "./footer.vue?vue&type=template&id=07da019f&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=07da019f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-07da019f"

export default script